module.exports = "<div *ngIf=\"active\">\n    <ng-content></ng-content>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/controls/tabs/tab/tab.component.html
// module id = ./src/app/controls/tabs/tab/tab.component.html
// module chunks = main